/* THINK SCRAP UTM attribution v1.0
 * Draft theme only. Stores first/last UTM touches for 30 days in this browser,
 * subject to Shopify's marketing-consent decision, and copies them to private
 * cart attributes for display in Shopify Admin order details.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'think_scrap_utm_attribution_v1';
  var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
  var UTM_FIELDS = ['source', 'medium', 'campaign', 'content'];
  var syncQueue = Promise.resolve();
  var lastRequestedPayload = '';

  function marketingAllowed() {
    try {
      return !!(window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.marketingAllowed === 'function' &&
        window.Shopify.customerPrivacy.marketingAllowed());
    } catch (error) {
      return false;
    }
  }

  function currentTouch() {
    var params = new URLSearchParams(window.location.search);
    var touch = {
      at: new Date().toISOString(),
      landing: window.location.pathname.substring(0, 240)
    };
    var found = false;
    UTM_FIELDS.forEach(function (field) {
      var raw = (params.get('utm_' + field) || '').trim();
      touch[field] = raw.replace(/[\u0000-\u001f\u007f]/g, '').substring(0, 150);
      if (touch[field]) found = true;
    });
    return found ? touch : null;
  }

  function readStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return { record: null, expired: false };
      var value = JSON.parse(raw);
      if (value && value.first && value.last &&
          typeof value.expiresAt === 'number' &&
          value.expiresAt > Date.now()) {
        return { record: value, expired: false };
      }
      window.localStorage.removeItem(STORAGE_KEY);
      return { record: null, expired: true };
    } catch (error) {
      return { record: null, expired: false };
    }
  }

  function saveStored(record) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch (error) {
      // Browsers that block storage may still retain attribution in the cart.
    }
  }

  function removeStored() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Storage might be disabled.
    }
  }

  function attributesFor(record) {
    var attributes = {};
    ['first', 'last'].forEach(function (position) {
      var touch = record && record[position] ? record[position] : {};
      UTM_FIELDS.forEach(function (field) {
        attributes['__ts_' + position + '_' + field] = touch[field] || '';
      });
      attributes['__ts_' + position + '_at'] = touch.at || '';
      attributes['__ts_' + position + '_landing'] = touch.landing || '';
    });
    return attributes;
  }

  function updateCart(attributes) {
    if (typeof window.fetch !== 'function') return;
    var payload = JSON.stringify({ attributes: attributes });
    if (payload === lastRequestedPayload) return;
    lastRequestedPayload = payload;

    syncQueue = syncQueue.catch(function () {
      // Let the next write proceed after a network failure.
    }).then(function () {
      var root = (window.Shopify && window.Shopify.routes &&
        window.Shopify.routes.root) || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      return window.fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: payload
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart attribute sync failed');
      });
    }).catch(function () {
      lastRequestedPayload = '';
    });
  }

  function refreshAttribution() {
    var state = readStored();

    // A visitor's consent withdrawal also removes our saved attribution.
    if (!marketingAllowed()) {
      if (state.record || state.expired) {
        removeStored();
        updateCart(attributesFor(null));
      }
      return;
    }

    var touch = currentTouch();
    var record = state.record;
    if (touch) {
      if (!record) {
        record = {
          first: touch,
          last: touch,
          expiresAt: Date.now() + MAX_AGE_MS
        };
      } else {
        // A direct revisit never replaces the last known tagged campaign.
        record.last = touch;
      }
      saveStored(record);
    }

    if (record) {
      updateCart(attributesFor(record));
    } else if (state.expired) {
      // Avoid attributing a purchase to a campaign older than 30 days.
      updateCart(attributesFor(null));
    }
  }

  document.addEventListener('visitorConsentCollected', refreshAttribution);

  function initialize() {
    if (window.Shopify && window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.marketingAllowed === 'function') {
      refreshAttribution();
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (!error) refreshAttribution();
        }
      );
    }
    // Fail closed if Shopify's consent API is unavailable.
  }

  initialize();
})();